import accountFormEmailReducer from 'src/app/redux/reducers/registration/account/accountFormEmailReducer';
import accountFormPasswordReducer from 'src/app/redux/reducers/registration/account/accountFormPasswordReducer';
import accountFormRegulationsReducer from 'src/app/redux/reducers/registration/account/accountFormRegulationsReducer';
import accountFormAgreementsReducer from 'src/app/redux/reducers/registration/account/accountFormAgreementsReducer';
import accountFormReducer from 'src/app/redux/reducers/registration/account/accountFormReducer';
import confirmAccountReducer from 'src/app/redux/reducers/registration/confirmAccountReducer';
import experienceEmployerReducer from 'src/app/redux/reducers/registration/experience/experienceEmployerReducer';
import registrationReducer from 'src/app/redux/reducers/registration/registrationReducer';
import experienceJobReducer from 'src/app/redux/reducers/registration/experience/experienceJobReducer';
import experienceDateFromReducer from 'src/app/redux/reducers/registration/experience/experienceDateFromReducer';
import experienceDateToReducer from 'src/app/redux/reducers/registration/experience/experienceDateToReducer';
import experienceFormReducer from 'src/app/redux/reducers/registration/experience/experienceFormReducer';
import experienceAgreementsReducer from 'src/app/redux/reducers/registration/experience/experienceAgreementsReducer';
import experienceCountryReducer from 'src/app/redux/reducers/registration/experience/experienceCountryReducer';
import experienceCityReducer from 'src/app/redux/reducers/registration/experience/experienceCityReducer';



export default {
  registrationReducer,
  accountFormEmailReducer,
  accountFormPasswordReducer,
  accountFormRegulationsReducer,
  accountFormAgreementsReducer,
  accountFormReducer,
  confirmAccountReducer,
  experienceEmployerReducer,
  experienceJobReducer,
  experienceDateFromReducer,
  experienceDateToReducer,
  experienceFormReducer,
  experienceAgreementsReducer,
  experienceCountryReducer,
  experienceCityReducer
};

